export const IS_FINAL = [
  { label: 'Готова к заселению', value: 'false' },
  { label: 'Передача в эксплуатацию', value: 'true' },
];
